import React from 'react';

function createContextStore({ displayName, defaultValue }) {
  const Store = React.createContext(defaultValue);
  Store.displayName = displayName;

  const StoreProvider = ({ children, initialState, reducer }) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    return (
      <Store.Provider value={[state, dispatch]}>{children}</Store.Provider>
    );
  };
  const useStore = () => React.useContext(Store);

  return {
    useStore,
    StoreProvider,
  };
}

export default createContextStore;
